import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import Link from 'next/link';
// Hooks
import useIsMobile from '../../hooks/useIsMobile';

const JobOfferDomainItem = ({
  layout, title, illustration, introduction, url,
}) => {
  const [isMobile] = useIsMobile();

  const renderImage = useCallback(() => (
    <div className="relative" style={{ height: '18.75rem' }}>
      <Image
        src={`${illustration}?fm=webp&w=${isMobile ? 820 : 700}&h=${isMobile ? 300 : 300}`}
        alt={title}
        layout="fill"
        objectFit="cover"
        loader={({ src }) => src}
      />
    </div>
  ), [illustration, title]);

  const renderBody = useCallback(() => (
    <>
      <h3 className="medium-weight">{title}</h3>
      <p className="grey-600-text">{introduction}</p>
    </>
  ), [introduction, title]);

  return (
    <Link href={url} passHref>
      <a>
        {isMobile ? (
          <div className="mt-5">
            {renderImage()}
            {renderBody()}
          </div>
        ) : (
          <div className="d-flex align-center mt-5">
            <div className="pr-5" style={{ width: '50%' }}>
              {layout === 'inverted' ? renderBody() : renderImage()}
            </div>
            <div className="pl-5" style={{ width: '50%' }}>
              {layout === 'inverted' ? renderImage() : renderBody()}
            </div>
          </div>
        )}
      </a>
    </Link>
  );
};

JobOfferDomainItem.propTypes = {
  layout: PropTypes.oneOf(['default', 'inverted']),
  title: PropTypes.string.isRequired,
  illustration: PropTypes.string.isRequired,
  introduction: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

JobOfferDomainItem.defaultProps = {
  layout: 'default',
};

export default JobOfferDomainItem;
